import { Component, OnInit , Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

// import { LoanService } from "../../../../loan/shared/loan.service";
import { PrintpassbookService } from "../../../shared/print/printpassbook.service";
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { SavingsService } from "../../../../savings/shared/savings.service";
import { ToasterserviceService } from "../../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rptpassbookpopup',
  templateUrl: './rptpassbookpopup.component.html',
  styleUrls: ['./rptpassbookpopup.component.css']
})
export class RptpassbookpopupComponent implements OnInit {

  CustomerList: any[] =[];
  BranchList: any[] = [];
  CentreList: any[] = [];
  SavingsIdList: any[] = [];
  toast : Toastpayload;

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private savingsService: SavingsService,
    private printpassbookService: PrintpassbookService,
    private CommonmastersService: CommonmastersService,
    private toasterserviceService: ToasterserviceService,
    ) { }

  ngOnInit() {
    
    // this.GetCustomer();
    this.GetBranch();
    this.data.LoanToDate = new Date(localStorage.getItem("ApplicationDate")).toUTCString();

    this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.data.CentreId = 0;
    this.data.customerId = 0;
    this.data.SavingsId = 0;
  }

  GenerateReports(): void {
    
    // this.data.customerId = this.data.customerId;
    // this.data.SavingsId = this.data.SavingsId;
    this.data.ReportName = "PassBookReport";
    this.printpassbookService.GenerateReport(this.data);
    this.dialogRef.close();

    // toastr Notification
    this.toast = {
      message: "Please wait, the report is loading in the new tab !",
      title: 'Report', 
      ic:  {
        timeOut: 5000,
        closeButton: true,
      } as IndividualConfig,
      type: 'info',    
    };
    this.toasterserviceService.showToast(this.toast);

  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;

      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];

      //auto selecting the centre based on branch selected.
      this.SelectCentre(this.data.BranchId);
      
    })
  }

  SelectCentre(branchId : any){

    // Clear the customers while branch changed
    this.CustomerList = [];

    this.CommonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
      this.CentreList = data;
    })

  }

  SelectCustomer(customerId: any) {

    this.CommonmastersService.GetCustomerListByCentreId(this.data).subscribe(data => {
      this.CustomerList = data;
    })
  }

  SelectSavingsNo(customerId: any) {
    this.data.CustomerId =customerId;

    this.savingsService.GetSavingsIdByCustomerId(this.data).subscribe(data => {
      this.SavingsIdList = data;
  })
}

}
